module.exports = __webpack_public_path__ + "dfe0dfa0d70c84ab95d56cd4c28c3ad6.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./client/resources/logo.jpg
 ** module id = 951
 ** module chunks = 1
 **/